/**
 * The Knowledge Base routes. One hierarchy — Categories → subjects in a
 * category → the Guide Viewer (where all real work happens: generate,
 * curate, read, edit, approve) — plus General Knowledge (rules).
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import { CategoriesPage } from './CategoriesPage.js';
import { CategoryWizard } from './CategoryWizard.js';
import { CategorySubjectsPage } from './CategorySubjectsPage.js';
import { GuideViewerPage } from './GuideViewerPage.js';
import { DocumentPage } from './DocumentPage.js';
import { RulesPage } from './RulesPage.js';
import { RuleDetailPage } from './RuleDetailPage.js';

export const KnowledgeRoutes = () => (
  <Routes>
    {/* bare /knowledge (the UserMenu entry's parent) lands on Subjects */}
    <Route index element={<Navigate to="categories" replace />} />
    <Route path="categories" element={<CategoriesPage />} />
    {/* before :templateId, or "new" would be read as an id */}
    <Route path="categories/new" element={<CategoryWizard />} />
    <Route path="categories/:templateId" element={<CategorySubjectsPage />} />
    <Route path="subjects/:subjectId/review" element={<GuideViewerPage />} />
    <Route path="subjects/:subjectId/review/:itemId" element={<GuideViewerPage />} />
    <Route path="rules" element={<RulesPage />} />
    <Route path="buckets/:bucketId" element={<RulesPage />} />
    <Route path="buckets/:bucketId/documents/:documentId" element={<DocumentPage />} />
    <Route path="rules/:ruleId" element={<RuleDetailPage />} />
  </Routes>
);
